var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:_vm.isFullscreen ? 'el-icon-crop' : 'el-icon-full-screen',staticStyle:{"color":"#ffffff","font-size":"18px"},on:{"click":_vm.click}})])}
var staticRenderFns = []

export { render, staticRenderFns }